// Draft-only display grouping; catalogue Product Types stay unchanged.
function avCategoryParams(search) {
  const params = new URLSearchParams(search);
  const key = 'filter.p.product_type';
  if (params.getAll(key).some(v => v === 'Briefcase' || v === 'brifecase')) {
    ['Briefcase', 'brifecase'].forEach(v => { if (!params.getAll(key).includes(v)) params.append(key, v); });
  }
  return params;
}
class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 500);

		const facetForm = this.querySelector("form");
		facetForm.addEventListener("input", (event) => {
   if (event.target.matches('.av-filter-brand-search__input')) {
    const section = event.target.closest('.collection-filter-section--designers');
    const term = event.target.value.trim().toLocaleLowerCase();
    section.classList.toggle('av-filter-searching', !!term);
    let matches = 0;
    section.querySelectorAll('.collection-filter-option').forEach(option => {
     const match = option.textContent.toLocaleLowerCase().includes(term);
     option.hidden = !match;
     if (match) matches++;
    });
    section.querySelector('.av-filter-brand-search__empty').hidden = matches > 0;
    return;
   }
   this.debouncedOnSubmit(event);
  });
  facetForm.addEventListener('keydown', event => {
   if (event.key === 'Enter' && event.target.matches('.av-filter-brand-search__input')) event.preventDefault();
  });

		const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
		if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

		const facetButton = this.querySelector(".facets__button-show");

		const facetsContainer = this.querySelector(".facets__container");
		const closeFacets = () => {
			facetsContainer?.classList.remove("active");
			document.body.classList.remove("overflow-hidden", "filter-open");
   if (facetsContainer?.contains(document.activeElement)) facetButton?.focus();
		};
		if (facetsContainer) {
			setTimeout(() => {
				facetsContainer.style.display = "flex";
			}, 600);
			facetsContainer.addEventListener("click", (event) => {
				if (event.target === facetsContainer) closeFacets();
			});
		}

		this.addEventListener('keydown', event => {
   if (event.key === 'Escape' && facetsContainer?.classList.contains('active')) {
    event.preventDefault(); event.stopPropagation(); closeFacets(); facetButton?.focus();
   }
  });
  this.addEventListener("click", (event) => {
			if (event.target.closest(".facets-modal__close")) {
				closeFacets();
				return;
			}
			if (
				facetsContainer?.classList.contains("active") &&
				event.target.closest(".facets__container") === facetsContainer &&
				!event.target.closest("#FacetsWrapperDesktop")
			) {
				closeFacets();
				return;
			}
			const toggle = event.target.closest(".collection-filter-designers-toggle");
			if (!toggle || !this.contains(toggle)) return;
			const designersSection = toggle.closest(".collection-filter-section--designers");
			const expanded = toggle.getAttribute("aria-expanded") === "true";
			toggle.setAttribute("aria-expanded", String(!expanded));
			designersSection?.classList.toggle(
				"collection-filter-section--expanded",
				!expanded
			);
		});

		if (facetButton) {
			facetButton.onclick = (event) => {
				let labelHide = event.currentTarget.querySelector(".label-hide");
				let labelShow = event.currentTarget.querySelector(".label-show");

				labelHide.classList.toggle("hidden");
				labelShow.classList.toggle("hidden");

				let container = labelHide
					.closest("form")
					.querySelector(".facets__container");

				container.classList.add("active");
				document.body.classList.add("overflow-hidden", "filter-open");

				if (
					document.querySelector(
						".facets__container--horizontal:not(.active)"
					) != null
				) {
					let horizontalFilters = document.querySelector(
						".facets__container--horizontal:not(.active)"
					);
					horizontalFilters.classList.add("visible_container");

					setTimeout(
						() => horizontalFilters.classList.remove("visible_container"),
						600
					);
				}

			};

			if (document.getElementById("SortBy") != null) {
				let select = document.getElementById("SortBy");
				select.addEventListener("click", () => select.classList.toggle("open"));
				select.addEventListener("blur", () => select.classList.remove("open"));
			}

			const facetCloseButton = this.querySelector(".facets-modal__close");
			facetCloseButton.addEventListener("click", closeFacets);

			const mobileApplyButton = this.querySelector(
				".collection-filter-mobile-actions__apply"
			);
			if (mobileApplyButton) {
				mobileApplyButton.addEventListener("click", closeFacets);
			}

			const collectionGridSection =
				document.querySelector(".collection-grid-section") ||
				document.querySelector(".section-search");
			let prevWidth = 0;
			const sectionResizeObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
			});
			sectionResizeObserver.observe(collectionGridSection);
		}

		const checkboxes = document.querySelectorAll(
			'#FacetFiltersFormMobile .js-filter input[type="checkbox"]'
		);
		const removebtn = document.querySelector(
			"#FacetFiltersFormMobile .facets-tag-wrapper"
		);
		const allChecked = Array.from(checkboxes).some(
			(checkbox) => checkbox.checked
		);

		if (allChecked) {
			removebtn?.classList.remove("active");
		} else {
			removebtn?.classList.add("active");
		}
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state
				? event.state.searchParams
				: FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener("popstate", onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll(".js-facet-remove").forEach((element) => {
			element.classList.toggle("disabled", disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true) {
    searchParams = avCategoryParams(searchParams).toString();
    if (window.avConditionController) return window.avConditionController.render(searchParams, event, updateURLHash);
		FacetFiltersForm.searchParamsPrev = searchParams;
  document.querySelectorAll('.collection-filter-mobile-actions__apply').forEach(button => { button.disabled = true; });
		const sections = FacetFiltersForm.getSections();
		const countContainer = document.getElementById("ProductCount");
		const countContainerDesktop = document.getElementById(
			"ProductCountDesktop"
		);
		document
			.getElementById("ProductGridContainer")
			.querySelector(".collection")
			.classList.add("loading");
		if (countContainer) {
			countContainer.classList.add("loading");
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.add("loading");
		}

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			const filterDataUrl = (element) => element.url === url;

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(url, event);
		});

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
	}

	static renderSectionFromFetch(url, event) {
		fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				const html = responseText;
				FacetFiltersForm.filterData = [
					...FacetFiltersForm.filterData,
					{ html, url },
				];
				FacetFiltersForm.renderFilters(html, event);
				FacetFiltersForm.renderProductGridContainer(html);
				FacetFiltersForm.renderProductCount(html);

				FacetFiltersForm.rerenderProductSliders();
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		FacetFiltersForm.renderFilters(html, event);
		FacetFiltersForm.renderProductGridContainer(html);
		FacetFiltersForm.renderProductCount(html);
		FacetFiltersForm.rerenderProductSliders();
	}

	static renderProductGridContainer(html) {
		document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
			.parseFromString(html, "text/html")
			.getElementById("ProductGridContainer").innerHTML;
		if (
			document.querySelector(".js-load-more") ||
			document.querySelector(".js-infinite-scroll")
		)
			loadMore();

		colorSwatches();
	}

	static renderProductCount(html) {
		const parsedHTML = new DOMParser().parseFromString(html, "text/html");
		const nextCount = parsedHTML.getElementById("ProductCount");
  if (!nextCount) return;
  const count = nextCount.innerHTML;
  document.querySelectorAll('.facets__product-count-text').forEach(element => {
   element.textContent = 'Items: ' + nextCount.textContent.replace(/[()]/g, '').trim();
  });
		const container = document.getElementById("ProductCount");
		const containerDesktop = document.getElementById("ProductCountDesktop");
		const mobileApplyButton = document.querySelector(
			".collection-filter-mobile-actions__apply"
		);
		const nextMobileApplyButton = parsedHTML.querySelector(
			".collection-filter-mobile-actions__apply"
		);
		if (container) { container.innerHTML = count; container.classList.remove("loading"); }
		if (containerDesktop) {
			containerDesktop.innerHTML = count;
			containerDesktop.classList.remove("loading");
		}
		if (mobileApplyButton && nextMobileApplyButton) {
			mobileApplyButton.textContent = nextMobileApplyButton.textContent;
   mobileApplyButton.disabled = false;
		}
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, "text/html");

		const facetDetailsElements = parsedHTML.querySelectorAll(
			"#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
		);
		const matchesIndex = (element) => {
			const jsFilter = event ? event.target.closest(".js-filter") : undefined;
			return jsFilter
				? element.dataset.index === jsFilter.dataset.index
				: false;
		};
		const facetsToRender = Array.from(facetDetailsElements).filter(
			(element) => !matchesIndex(element)
		);
		const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

		facetsToRender.forEach((element) => {
			const filterEl = document.querySelector(
				`.js-filter[data-index="${element.dataset.index}"]`
			);

			if (filterEl) {
				filterEl.innerHTML = element.innerHTML;
			}
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (countsToRender)
			FacetFiltersForm.renderCounts(
				countsToRender,
				event.target.closest(".js-filter")
			);

		const checkboxes = document.querySelectorAll(
			'#FacetFiltersFormMobile .js-filter input[type="checkbox"]'
		);
		const removebtn = document.querySelector(
			"#FacetFiltersFormMobile .facets-tag-wrapper"
		);
		const allChecked = Array.from(checkboxes).some(
			(checkbox) => checkbox.checked
		);

		if (allChecked) {
			removebtn?.classList.remove("active");
		} else {
			removebtn?.classList.add("active");
		}
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = [
			".active-facets-mobile",
			".active-facets-desktop",
			".collection-active-filters",
		];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			const currentActiveFacetsElement = document.querySelector(selector);
			if (currentActiveFacetsElement) {
				currentActiveFacetsElement.innerHTML = activeFacetsElement.innerHTML;
			}
		});

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = [
			".mobile-facets__open",
			".mobile-facets__count",
			".sorting",
		];

		mobileElementSelectors.forEach((selector) => {
			if (!html.querySelector(selector)) return;
			document.querySelector(selector).innerHTML =
				html.querySelector(selector).innerHTML;
		});
	}

	static renderCounts(source, target) {
		const targetElement = target.querySelector(".facets__selected");
		const sourceElement = source.querySelector(".facets__selected");

		const targetElementAccessibility = target.querySelector(".facets__summary");
		const sourceElementAccessibility = source.querySelector(".facets__summary");

		if (sourceElement && targetElement) {
			target.querySelector(".facets__selected").outerHTML =
				source.querySelector(".facets__selected").outerHTML;
		}

		if (targetElementAccessibility && sourceElementAccessibility) {
			target.querySelector(".facets__summary").outerHTML =
				source.querySelector(".facets__summary").outerHTML;
		}
	}

	static updateURLHash(searchParams) {
		history.pushState(
			{ searchParams },
			"",
			`${window.location.pathname}${searchParams && "?".concat(searchParams)}`
		);
	}

	static getSections() {
		return [
			{
				section: document.getElementById("product-grid").dataset.id,
			},
		];
	}

	static rerenderProductSliders() {
		const sliders = document.querySelectorAll(".product-card-js");

		sliders.forEach((slider) => {
			if (slider?.swiper) return;
			new Swiper(slider, {
				initialSlide: 0,
				pagination: {
					el: ".product-pagination .swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: ".product-button-group .swiper-button-next",
					prevEl: ".product-button-group .swiper-button-prev",
				},
				allowTouchMove: false,
				on: {
					init(swiper) {
						swiper.slideTo(0, 0, false);
					},
				},
			});
		});
	}

	createSearchParams(form) {
		const formData = new FormData(form);
		const searchParams = new URLSearchParams();
        for (const [key, value] of formData.entries()) {
            if (String(value).trim() !== "") searchParams.append(key, value);
        }
        const typeKey = 'filter.p.product_type';
        if (searchParams.getAll(typeKey).some(v => v === 'Briefcase' || v === 'brifecase')) {
          ['Briefcase', 'brifecase'].forEach(v => { if (!searchParams.getAll(typeKey).includes(v)) searchParams.append(typeKey, v); });
        }
        return searchParams.toString();
	}

	onSubmitForm(searchParams, event) {
		FacetFiltersForm.renderPage(searchParams, event);
	}

	onSubmitHandler(event) {
		event.preventDefault();
		const sortFilterForms = document.querySelectorAll(
			"facet-filters-form form"
		);
		if (event.srcElement.className == "mobile-facets__checkbox") {
			const searchParams = this.createSearchParams(
				event.target.closest("form")
			);
			this.onSubmitForm(searchParams, event);
		} else {
			const forms = [];
			const currentForm =	event.target.closest('form');
			sortFilterForms.forEach((form) => {
				if (
					form.id === "FacetSortForm" ||
					form.id === "FacetFiltersForm" ||
					form.id === "FacetFiltersFormMobile" ||
					form.id === "FacetSortDrawerForm"
				) {
					const noJsElements = document.querySelectorAll(".no-js-list");
					noJsElements.forEach((el) => el.remove());
					if (currentForm === form) {
						forms.push(this.createSearchParams(form))
					} else {
						const searchParamsWithoutProductType = this.createSearchParams(form)
							?.split('&')
							?.filter((element) => !element.startsWith('filter.p.product_type'))
							?.join('&') || '';

						forms.push(searchParamsWithoutProductType)
					}
				}
			});
			this.onSubmitForm(forms.join("&"), event);
		}
	}

	onActiveFilterClick(event) {
		event.preventDefault();
    const category = event.currentTarget.dataset.avCategory;
    if (category === 'Briefcase' || category === 'brifecase') {
      const url = new URL(event.currentTarget.href, location.href);
      const keep = url.searchParams.getAll('filter.p.product_type').filter(v => v !== 'Briefcase' && v !== 'brifecase');
      url.searchParams.delete('filter.p.product_type');
      keep.forEach(v => url.searchParams.append('filter.p.product_type', v));
      event.currentTarget.href = url.toString();
    }
    if (window.avConditionController) {
      const link = event.currentTarget;
      const params = new URLSearchParams(new URL(link.href, location.href).search);
      const clear = link.matches('.active-facets__button-remove, .collection-filter-mobile-actions__clear');
      params.delete('av_condition'); params.delete('av_page'); params.delete('page');
      if (!clear) {
        window.avConditionController.values(window.avConditionController.params).forEach(value => params.append('av_condition', value));
        params.delete('av_category');
        window.avConditionController.categories?.(window.avConditionController.params).forEach(value => params.append('av_category', value));
      }
      window.avConditionController.render(params.toString(), null);
      return;
    }
		FacetFiltersForm.toggleActiveFacets();
		const url =
			event.currentTarget.href.indexOf("?") == -1
				? ""
				: event.currentTarget.href.slice(
						event.currentTarget.href.indexOf("?") + 1
				  );
		FacetFiltersForm.renderPage(url);

		// const checkboxes = document.querySelectorAll('#FacetFiltersFormMobile .js-filter input[type="checkbox"]');
		const removebtn = document.querySelector(
			"#FacetFiltersFormMobile .facets-tag-wrapper"
		);
		// const allChecked = Array.from(checkboxes).every(checkbox => !checkbox.checked);
		removebtn?.classList.add("active");

		// if (allChecked) {
		// 	console.log("All checkboxes are checked.");
		// } else {
		// 	console.log("Not all checkboxes are checked.");
		// }
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll("input").forEach((element) =>
			element.addEventListener("change", this.onRangeChange.bind(this))
		);
		this.setMinAndMaxValues();
		this.controlSlider();
		this.controlInput();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll("input");
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute("max", maxInput.value);
		if (minInput.value) maxInput.setAttribute("min", minInput.value);
		if (minInput.value === "") maxInput.setAttribute("min", 0);
		if (maxInput.value === "")
			minInput.setAttribute("max", maxInput.getAttribute("max"));
	}

	adjustToValidValues(input) { if (input.value === "") return;
		const value = Number(input.value);
		const min = Number(input.getAttribute("min"));
		const max = Number(input.getAttribute("max"));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}

	fillSlider() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		inputRangeWrappers.forEach((inputWrapper) => {
			const inputsRange = inputWrapper.querySelectorAll(".field__range");
			const inputRangeFrom = inputsRange[0];
			const inputRangeTo = inputsRange[1];

			const range = inputRangeTo.max - inputRangeTo.min;
			const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
			const toCurrent = inputRangeTo.value - inputRangeTo.min;
			const minRange = (fromCurrent / range) * 100;
			const maxRange = (toCurrent / range) * 100;

			inputWrapper.setAttribute(
				"style",
				`--range-min: ${minRange}%; --range-max: ${maxRange}%`
			);
		});
	}

	controlSlider() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		const inputNumberWrappers = document.querySelectorAll(
			".facets__price .facets__price-wrapper"
		);

		inputRangeWrappers.forEach((inputWrapper, index) => {
			const inputsRange = inputWrapper.querySelectorAll(".field__range");
			const inputRangeFrom = inputsRange[0];
			const inputRangeTo = inputsRange[1];
			const inputNumberFrom =
				inputNumberWrappers[index].querySelectorAll(".field__input")[0];
			const inputNumberTo =
				inputNumberWrappers[index].querySelectorAll(".field__input")[1];

			inputRangeFrom.oninput = () => {
				const from = parseInt(inputRangeFrom.value, 10);
				const to = parseInt(inputRangeTo.value, 10);
				if (from > to) {
					inputRangeFrom.value = to;
					inputNumberFrom.value = to;
				} else {
					inputNumberFrom.value = from;
				}

				this.fillSlider();
			};

			if (Number(inputRangeTo.value) <= 0) {
				inputRangeTo.style.zIndex = 2;
			} else {
				inputRangeTo.style.zIndex = 0;
			}

			inputRangeTo.oninput = () => {
				const from = parseInt(inputRangeFrom.value, 10);
				const to = parseInt(inputRangeTo.value, 10);
				if (from <= to) {
					inputRangeTo.value = to;
					inputNumberTo.value = to;
				} else {
					inputNumberTo.value = from;
					inputRangeTo.value = from;
				}

				if (Number(inputRangeTo.value) <= 0) {
					inputRangeTo.style.zIndex = 2;
				} else {
					inputRangeTo.style.zIndex = 0;
				}

				this.fillSlider();
			};
		});
	}

	controlInput() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		const inputNumberWrappers = document.querySelectorAll(
			".facets__price .facets__price-wrapper"
		);

		inputNumberWrappers.forEach((inputWrapper, index) => {
			const inputsNumber = inputWrapper.querySelectorAll(".field__input");
			const inputNumberFrom = inputsNumber[0];
			const inputNumberTo = inputsNumber[1];
			const inputRangeFrom =
				inputRangeWrappers[index].querySelectorAll(".field__range")[0];
			const inputRangeTo =
				inputRangeWrappers[index].querySelectorAll(".field__range")[1];

			inputNumberFrom.oninput = () => { if (inputNumberFrom.value === "") { inputRangeFrom.value = inputRangeFrom.min; this.fillSlider(); return; }
				const from = inputNumberFrom.value === "" ? parseInt(inputRangeFrom.min, 10) : parseInt(inputNumberFrom.value, 10);
				const to = parseInt(inputNumberTo.value, 10);
				if (from > to) {
					inputRangeFrom.value = to;
					inputNumberFrom.value = to;
				} else {
					inputRangeFrom.value = from;
				}

				this.fillSlider();
			};

			inputNumberTo.oninput = () => { if (inputNumberTo.value === "") { inputRangeTo.value = inputRangeTo.max; this.fillSlider(); return; }
				const from = inputNumberFrom.value === "" ? parseInt(inputRangeFrom.min, 10) : parseInt(inputNumberFrom.value, 10);
				const to = parseInt(inputNumberTo.value, 10);
				if (from <= to) {
					inputRangeTo.value = to;
					inputNumberTo.value = to;
				} else {
					inputNumberTo.value = from;
				}

				this.fillSlider();
			};
		});
	}
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		const facetLink = this.querySelector("a");
		facetLink.setAttribute("role", "button");
		facetLink.addEventListener("click", this.closeFilter.bind(this));
		facetLink.addEventListener("keyup", (event) => {
			event.preventDefault();
			if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
		});
	}

	closeFilter(event) {
		event.preventDefault();
		const form =
			this.closest("facet-filters-form") ||
			document.querySelector("facet-filters-form");
		form.onActiveFilterClick(event);
	}
}

customElements.define("facet-remove", FacetRemove);

/* Draft collection filtering: independent Condition and Bags primary Category.
   Product-ID mapping is theme-local. Product data and carry modes are untouched. */
(() => {
  const controls = document.querySelector('[data-av-condition-controls]');
  if (!controls || !location.pathname.startsWith('/collections/')) return;
  const categoryControls = document.querySelector('[data-av-category-controls]');
  const categoryMap = categoryControls ? JSON.parse(categoryControls.querySelector('[data-av-category-map]').textContent) : {};
  const categoryNames = categoryControls ? [...categoryControls.querySelectorAll('input[name="av_category"]')].map(input => input.value) : [];
  const grades = ['Pristine', 'Excellent', 'Great', 'Good', 'As Is'];
  const controller = {
    sequence: 0,
    cache: new Map(),
    params: new URLSearchParams(location.search),
    values(params) { return [...new Set(params.getAll('av_condition'))].filter(v => grades.includes(v)); },
    categories(params) {
      const aliases = {"Round Bags":"Other Shapes","Trunk Bags":"Other Shapes","Barrel Bags":"Other Shapes","Novelty Bags":"Other Shapes","Wallets on Chain":"Wallets & Small Leather Goods","Wallets & Card Holders":"Wallets & Small Leather Goods","Phone Bags":"Wallets & Small Leather Goods","Duffle & Travel Bags":"Travel Bags"};
      return [...new Set(params.getAll('av_category').map(v => aliases[v] || v))].filter(v => categoryNames.includes(v));
    },
    category(card) { return categoryMap[card.dataset.avProductId] || 'Other Bags'; },
    nativeParams(params) {
      const native = new URLSearchParams(params);
      ['av_condition', 'av_category', 'av_page', 'page', 'section_id'].forEach(k => native.delete(k));
      if (categoryControls) native.delete('filter.p.product_type');
      return native;
    },
    sync(params) {
      this.params = new URLSearchParams(params);
      const selected = this.values(this.params), categories = this.categories(this.params);
      controls.querySelectorAll('input').forEach(input => { input.checked = selected.includes(input.value); });
      controls.querySelector('[data-av-condition-selected]').textContent = selected.length ? ` (${selected.length})` : '';
      categoryControls?.querySelectorAll('input[name="av_category"]').forEach(input => { input.checked = categories.includes(input.value); });
      if (categoryControls) categoryControls.querySelector('[data-av-category-selected]').textContent = categories.length ? ` (${categories.length})` : '';
      const active = document.querySelector('.collection-active-filters');
      active?.querySelectorAll('[data-av-condition-chip], [data-av-category-chip]').forEach(e => e.remove());
      [['Condition', selected, 'avConditionChip'], ['Category', categories, 'avCategoryChip']].forEach(([label, values, attribute]) => values.forEach(value => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'active-facets__button focus-inset'; button.dataset[attribute] = value;
        button.setAttribute('aria-label', `Remove ${label}: ${value}`); button.textContent = `${label}: ${value} ×`; active?.prepend(button);
      }));
      if (selected.length || categories.length) document.querySelectorAll('.facets-remove__all .facet-remove').forEach(el => {
        el.classList.remove('facet-remove--disabled'); el.classList.add('active');
      });
    },
    busy(value) {
      document.getElementById('ProductGridContainer')?.setAttribute('aria-busy', String(value));
      document.querySelector('#ProductGridContainer .collection')?.classList.toggle('loading', value);
      document.querySelectorAll('.collection-filter-mobile-actions__apply').forEach(b => { b.disabled = value; });
    },
    status(message, error = false) {
      controls.querySelector('[data-av-condition-status]').textContent = message;
      controls.querySelector('[data-av-condition-retry]').hidden = !error;
      if (categoryControls) categoryControls.querySelector('[data-av-category-status]').textContent = message;
    },
    async fetchPage(params, page, signal) {
      const query = this.nativeParams(params);
      query.set('section_id', document.getElementById('product-grid').dataset.id); query.set('page', String(page));
      const response = await fetch(`${location.pathname}?${query}`, { signal });
      if (!response.ok) throw new Error('Collection request failed');
      const html = await response.text(), doc = new DOMParser().parseFromString(html, 'text/html');
      const meta = doc.querySelector('[data-av-condition-page]');
      if (!meta || Number(meta.dataset.currentPage) !== page) throw new Error('Incomplete collection response');
      return { html, doc, total: Number(meta.dataset.total), pages: Number(meta.dataset.pages), size: Number(meta.dataset.size) };
    },
    async all(params, signal, first) {
      const key = this.nativeParams(params).toString(), entry = this.cache.get(key);
      if (entry && Date.now() - entry.time < 60000) return entry.data;
      first = first || await this.fetchPage(params, 1, signal);
      if (first.pages > 100 || !Number.isFinite(first.total)) throw new Error('Collection exceeds preview capacity');
      const pages = [first]; let next = 2;
      await Promise.all(Array.from({ length: Math.min(3, Math.max(0, first.pages - 1)) }, async () => {
        while (next <= first.pages) { const page = next++; pages[page - 1] = await this.fetchPage(params, page, signal); }
      }));
      const cards = pages.flatMap(page => [...page.doc.querySelectorAll('#product-grid > li[data-av-product-id]')]);
      if (cards.length !== first.total || new Set(cards.map(card => card.dataset.avProductId)).size !== first.total) throw new Error('Collection changed during loading; please retry');
      const data = { first, cards, size: first.size };
      if (this.cache.size >= 3) this.cache.delete(this.cache.keys().next().value);
      this.cache.set(key, { time: Date.now(), data }); return data;
    },
    matches(cards, selected, categories) {
      return cards.filter(card => (!selected.length || selected.includes(card.dataset.avConditionGrade)) && (!categories.length || categories.includes(this.category(card))));
    },
    counts(cards, params) {
      const selected = this.values(params), categories = this.categories(params);
      const categoryBase = this.matches(cards, selected, []), conditionBase = this.matches(cards, [], categories);
      controls.querySelectorAll('input').forEach(input => {
        const count = conditionBase.filter(card => card.dataset.avConditionGrade === input.value).length;
        controls.querySelector(`[data-av-condition-count="${input.value}"]`).textContent = count;
      });
      categoryControls?.querySelectorAll('input[name="av_category"]').forEach(input => {
        const count = categoryBase.filter(card => this.category(card) === input.value).length;
        categoryControls.querySelector(`[data-av-category-count="${input.value}"]`).textContent = count;
        const option = input.closest('[data-av-category-option]');
        if (input.value === 'Other Bags') option.hidden = count === 0 && !categories.includes(input.value);
      });
    },
    updateCount(count) {
      document.querySelectorAll('.facets__product-count-text').forEach(el => { el.textContent = `Items: ${count}`; });
      ['ProductCount', 'ProductCountDesktop'].forEach(id => { const el = document.getElementById(id); if (el) el.textContent = `(${count})`; });
      document.querySelectorAll('.collection-filter-mobile-actions__apply').forEach(el => { el.textContent = `View ${count} pieces`; el.setAttribute('aria-label', `View ${count} pieces`); });
    },
    async render(searchParams, event, updateURL = true) {
      const params = avCategoryParams(searchParams), selected = this.values(params), categories = this.categories(params);
      params.delete('av_condition'); selected.forEach(v => params.append('av_condition', v));
      params.delete('av_category'); categories.forEach(v => params.append('av_category', v));
      if (categoryControls) params.delete('filter.p.product_type');
      const sequence = ++this.sequence;
      this.abort?.abort(); this.abort = new AbortController(); this.countAbort?.abort();
      this.sync(params); FacetFiltersForm.searchParamsPrev = params.toString();
      if (updateURL) FacetFiltersForm.updateURLHash(params.toString());
      this.busy(true); this.status('Updating pieces…');
      try {
        const custom = !!categoryControls || selected.length > 0;
        const first = await this.fetchPage(params, custom ? 1 : Math.max(1, Number(params.get('page')) || 1), this.abort.signal);
        const data = custom ? await this.all(params, this.abort.signal, first) : null;
        if (sequence !== this.sequence) return;
        FacetFiltersForm.renderFilters(first.html, event);
        FacetFiltersForm.renderProductGridContainer(first.html); FacetFiltersForm.renderProductCount(first.html);
        if (data) {
          this.counts(data.cards, params);
          const matches = this.matches(data.cards, selected, categories);
          const pageCount = Math.max(1, Math.ceil(matches.length / data.size));
          const page = Math.min(pageCount, Math.max(1, Math.floor(Number(params.get('av_page') || params.get('page')) || 1)));
          const grid = document.getElementById('product-grid');
          if (grid.tagName !== 'UL' && matches.length) throw new Error('Missing collection grid');
          if (grid.tagName === 'UL') {
            grid.hidden = false; grid.innerHTML = matches.slice((page - 1) * data.size, page * data.size).map(card => card.outerHTML).join('');
            grid.classList.remove('load-more-grid');
            const collection = grid.closest('.collection');
            collection.querySelectorAll('.js-load-more, .js-infinite-scroll, .js-hidden, .pagination-wrapper, .load-more').forEach(el => el.remove());
            [...collection.children].filter(el => el !== grid && !el.classList.contains('loading-overlay')).forEach(el => el.remove());
            const info = document.createElement('p'); info.className = 'av-condition-result-summary'; info.setAttribute('role', 'status');
            info.textContent = matches.length ? `${matches.length} pieces · Page ${page} of ${pageCount}` : 'No pieces match these filters. Try another selection or Reset.';
            collection.append(info);
            if (pageCount > 1) {
              const nav = document.createElement('nav'); nav.className = 'av-condition-pages'; nav.setAttribute('aria-label', 'Filtered results pages');
              [['Previous', page - 1, page === 1], ['Next', page + 1, page === pageCount]].forEach(([label, target, disabled]) => {
                const button = document.createElement('button'); button.type = 'button'; button.textContent = label; button.dataset.avConditionPage = target; button.disabled = disabled; nav.append(button);
              }); collection.append(nav);
            }
          }
          this.updateCount(matches.length);
          document.querySelectorAll('.js-filter input[type="checkbox"]').forEach(input => {
            const key = input.name === 'filter.p.product_type' ? 'avProductType' : input.name === 'filter.p.m.custom.designer_reference' ? 'avDesigner' : input.name === 'filter.v.availability' ? 'avAvailable' : null;
            if (!key) return;
            const count = matches.filter(card => {
              const value = card.dataset[key] || '';
              if (key === 'avProductType' && ['Briefcase', 'brifecase'].includes(input.value)) return ['Briefcase', 'brifecase'].includes(value);
              return key === 'avDesigner' ? value.split('/').pop() === input.value.split('/').pop() : value === input.value;
            }).length;
            const label = input.closest('li')?.querySelector('.collection-filter-option__count'); if (label) label.textContent = count;
            // Native counts must not leave zero options disabled when adding an OR value is valid.
            if (categoryControls) { input.disabled = false; input.closest('li')?.querySelector('label')?.classList.remove('facet-checkbox--disabled'); }
          });
        } else controls.querySelectorAll('[data-av-condition-count]').forEach(el => { el.textContent = ''; });
        this.sync(params); FacetFiltersForm.rerenderProductSliders(); this.busy(false); this.status('');
        if (controls.open && !data) this.loadCounts();
      } catch (error) {
        if (error.name === 'AbortError' || sequence !== this.sequence) return;
        this.busy(false); this.status('Results could not be updated. Retry or Reset.', true);
        const grid = document.getElementById('product-grid'); if (grid) grid.hidden = true;
        document.querySelectorAll('.collection-filter-mobile-actions__apply').forEach(b => { b.disabled = true; });
      }
    },
    async loadCounts() {
      this.countAbort?.abort(); this.countAbort = new AbortController(); const sequence = this.sequence;
      this.status('Loading filter counts…');
      try { const data = await this.all(this.params, this.countAbort.signal); if (sequence !== this.sequence) return; this.counts(data.cards, this.params); this.status(''); }
      catch (error) { if (error.name !== 'AbortError' && sequence === this.sequence) this.status('Counts could not be loaded. Retry.', true); }
    }
  };
  window.avConditionController = controller;
  controls.addEventListener('toggle', () => { if (controls.open) controller.loadCounts(); });
  categoryControls?.addEventListener('toggle', () => { if (categoryControls.open) controller.loadCounts(); });
  categoryControls?.querySelector('[data-av-category-toggle]')?.addEventListener('click', event => {
    event.preventDefault();
    const expanded = !categoryControls.hasAttribute('data-av-expanded');
    categoryControls.toggleAttribute('data-av-expanded', expanded);
    event.currentTarget.setAttribute('aria-expanded', String(expanded));
    event.currentTarget.textContent = expanded ? 'Show fewer categories' : 'Show all categories';
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-av-condition-chip], [data-av-category-chip], [data-av-condition-reset], [data-av-condition-page], [data-av-condition-retry]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation(); const params = new URLSearchParams(controller.params);
    if (button.hasAttribute('data-av-condition-chip') || button.hasAttribute('data-av-category-chip')) {
      const condition = button.hasAttribute('data-av-condition-chip'), key = condition ? 'av_condition' : 'av_category';
      const values = condition ? controller.values(params) : controller.categories(params), value = condition ? button.dataset.avConditionChip : button.dataset.avCategoryChip;
      params.delete(key); values.filter(v => v !== value).forEach(v => params.append(key, v)); params.delete('av_page'); params.delete('page');
    } else if (button.hasAttribute('data-av-condition-reset')) {
      params.delete('av_condition'); params.delete('av_page'); params.delete('page');
    } else if (button.hasAttribute('data-av-condition-page')) params.set('av_page', button.dataset.avConditionPage);
    else controller.cache.clear();
    controller.render(params.toString(), null).then(() => { if (button.hasAttribute('data-av-condition-page')) document.getElementById('product-grid')?.scrollIntoView({ block: 'start' }); });
  });
  controller.sync(controller.params);
  if (categoryControls || controller.values(controller.params).length || avCategoryParams(controller.params).toString() !== controller.params.toString()) controller.render(controller.params.toString(), null, false);
})();

if (!window.avConditionController && avCategoryParams(location.search).toString() !== new URLSearchParams(location.search).toString()) FacetFiltersForm.renderPage(location.search.slice(1), null, false);
